export default function setActiveProduct (vue, productid){
    for(const category in vue.$store.state.products){
        for(const product of vue.$store.state.products[category].Products){
            if(productid===product.Product.ProductCode){
                vue.$store.commit("setProduct", product);
            }
        }
    }
}